import "./scripts/attraction";

import "./styles/attractions.scss";
import "./styles/attraction.scss";
